package com.shadowings.gero.data.lessons.chapter9

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.TrueFalseContent
import com.shadowings.gero.presentation.component.MdCWord
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_preposizione_m_1
import gero.composeapp.generated.resources.exp_content_preposizione_m_2
import gero.composeapp.generated.resources.exp_content_preposizione_m_3
import gero.composeapp.generated.resources.exp_content_preposizione_m_4
import gero.composeapp.generated.resources.exp_content_preposizione_m_5
import gero.composeapp.generated.resources.exp_content_preposizione_m_6
import gero.composeapp.generated.resources.exp_content_preposizione_m_7
import gero.composeapp.generated.resources.exp_title_preposizione_m
import gero.composeapp.generated.resources.quiz_preposizione_m_1
import gero.composeapp.generated.resources.quiz_preposizione_m_2
import gero.composeapp.generated.resources.quiz_preposizione_m_3

fun getPreposizioneMContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_preposizione_m,
            content = Res.string.exp_content_preposizione_m_1,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_m,
            content = Res.string.exp_content_preposizione_m_2,
            face = Faces.Happy,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_m,
            content = Res.string.exp_content_preposizione_m_3,
            face = Faces.Happy,
            character = Characters.Alyn,
            composable = {
                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    MdCWord(
                        word = "M17-V28-X1:F1A-G17-O1h2:Z1",
                        rtl = false,
                        cart = false,
                        size = 64.dp
                    )
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_m,
            content = Res.string.exp_content_preposizione_m_4,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_m,
            content = Res.string.exp_content_preposizione_m_5,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_m,
            content = Res.string.exp_content_preposizione_m_6,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_m,
            content = Res.string.exp_content_preposizione_m_7,
            face = Faces.Happy,
            character = Characters.Alyn,
        )
    )
}

fun getPreposizioneMQuizContent(
    hiero: List<Hiero>,
    words: List<Word>,
    languageCode: String
): List<IQuizContent> {
    val trueFalseQuestions = listOf(
        TrueFalseContent(
            text = Res.string.quiz_preposizione_m_1,
            correct = true
        ),
        TrueFalseContent(
            text = Res.string.quiz_preposizione_m_2,
            correct = true
        ),
        TrueFalseContent(
            text = Res.string.quiz_preposizione_m_3,
            correct = false
        )
    )

    val hieroVari2Quizzes = getHieroVari2QuizContent(hiero, words, languageCode)
    val vocabVari2Quizzes = getVocabVari2QuizContent(
        getVocabVari2Content(words, languageCode),
        words,
        languageCode
    )

    val reviewQuizzes = (hieroVari2Quizzes + vocabVari2Quizzes).shuffled()

    return trueFalseQuestions + reviewQuizzes
}
